import { RuntimeEnvironments, MSAEnvironments } from './runtime-environments';

export const environment = {
  production: true,
  performance: false,
  internal: false,
  deployment: 'production',
  site: 'retailExternal',
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  No_OF_YEARS: 6,
  ALL_MONTHS: ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"],
  GLOBAL_HEADER_V8_JS: "https://n4v.web.vanguard.com/secure-site-components.js",

  LOGON_URL: 'https://logon.vanguard.com/logon?TARGET_OVERRIDE=https://confirmations.web.vanguard.com&authenticate=true',
  MEDALLIA_LIB:
    'https://mdl-medallia-digital.vanguard.com/pkg/1.0.0/web/external_libs/wdcusprem/2940/onsite/medallia-digital-embed.js',
  FORM_ID: '',
  SURVEY_KEY: 'medalliaSurveyLastShown',
  SURVEY_DURATION_DAYS: 90,
  SURVEY_PROBABILITY: 1.0,
  SURVEY_DELAY_MS: 30000,
  MEDALLIA_EXCLUDED_POIDS: ['2000752755'],

  // CONSUMER_API: 'https://api.ecs.us-east-1.rett.c1.vanguard.com/xs1-secure-site-consumer-api/',
  GRAPHQL_URI: 'https://apps.ecs.retp.c1.vanguard.com/xs1-secure-site-consumer-api/graphql',
  LEGACY_URL:'https://personal.vanguard.com',
  LEGACY_URL_PATH: '/us/XHTML/Confirms',
  GATEKEEPER_FEATURE_ID: 'ConfirmsRedirectCheck', 

  FLOODLIGHT_RTE: RuntimeEnvironments.PROD,
  MSA_ENVIRONMENT: MSAEnvironments.PRODUCTION,
  PERSONAL_DOMAIN: 'https://personal.vanguard.com',
  ADOBE_TARGET_ANTIFLICKER_JS:
    'https://corp.at2.assets.vgdynamic.info/files/js/core/antiflicker.min.js',
  C3_SERVERLESS_BUNDLE_JS:
    "https://mc3-static-assets.web.vanguard.com/vg-ccc-serverless/latest/vg-ccc-serverless.js",

  CONFIRMATIONS: {
    BASE_URL: 'https://personal1.vanguard.com/usa/api/confirmations',
    CONSUMER_ENDPOINT: '/consumer',
    CLIENT_LOG: '/client-log',
    SHARED_NAV_GRAPHQL_URL: 'https://pi.aemgraphql.vanguard.com/graphql/ct.atokv.domain.execute.json/port-shared-content/shared-nav',
    CONFIRMATIONS_GRAPHQL_URL: 'https://pi.aemgraphql.vanguard.com/graphql/ct.domain.execute.json/confirmations/confirmations',
    PAGE_META_DATA_GRAPHQL_URL: 'https://pi.aemgraphql.vanguard.com/graphql/tx.execute.json/vanguard-retail-common/pageMetaDataFragment;appID=/content/dam/content-fragments/vanguard-retail-common/page-metadata-fragments/rqf-client-confirmations-pagemeta', 
    GATEKEEPER_URL: '/gatekeeper',
    PDF_URL: '/pdf',
    CONFIRMATION_TYPES: '/confirmation-types',
    UPDATE_CONFIRMATION_STATUS: '',
    ADDRESS_URL: '/addresses',
    SUBMIT_CONFIRMATION_URL: '/submit-confirmation-reprint',
    OKTA_GROUP_URL: '/groups',
    INTERNAL_URL: 'https://confirmations.web.vanguard.com?secureMessage=true'
  },
  downloadAccountLink: {
    label: 'Download center',
    url: 'https://personal1.vanguard.com/usa/ofu-open-fin-exchange-webapp/ofx-welcome',
  },
};
